import {IStateParamsService, IStateService} from "angular-ui-router";
import * as _ from 'lodash';

const moment: any = require("moment");

require('./booking.less');

class BookingController {
    weekMode: boolean;
    query = {order: 'bookingId'};
    urlListener;
    activeState;
    orderCount;
    fromDate: Date;
    toDate: Date;
    weekNumber: number;
    year: number;
    numberOfWeeks: number;
    weeks = [];
    years = [];
    search = {};
    expanded = [];
    bookings;
    location;

    constructor(private toastService, private $state: IStateService, private $stateParams: IStateParamsService, private $filter, private $location, private $mdDialog, private Shipments, private ShipmentDefaults, private $scope) {
        this.urlListener = $scope.$on('$locationChangeSuccess', () => {
            if (this.activeState === this.$state.current.name) {
                this.setDatesFromUrl();
                this.getShipments();
            }
        });
    }

    $onInit() {
        this.location = localStorage.getItem('preferred-booking-location');
        this.weekMode = 'loggedin.expedition_booking_week' === this.$state.current.name;
        if (this.weekMode) {
            this.defineWeeks();
            this.defineYears();
            this.setCurrentWeekNumber();
            this.setCurrentYear();
            this.setDatesFromUrl();
            this.setDateRange();
        } else {
            this.setDatesFromUrl();
            this.setDate();
        }
        this.getShipments();
        this.activeState = angular.copy(this.$state.current.name);
    }

    $onDestroy() {
        this.urlListener();
    }

    updateLocation() {
        localStorage.setItem('preferred-booking-location', this.location);
    }

    setDatesFromUrl() {
        this.fromDate = this.$location.$$search.fromDate ? new Date(this.$location.$$search.fromDate) : undefined;
        this.toDate = this.$location.$$search.toDate ? new Date(this.$location.$$search.toDate) : undefined;

        if ((this.fromDate || this.toDate) && this.weekMode) {
            this.setCurrentWeekNumber(this.fromDate || this.fromDate);
            this.setCurrentYear(this.fromDate || this.toDate);
        }
    }

    setDate() {
        if (this.fromDate) {
            this.toDate = this.fromDate;
        } else {
            this.toDate = this.fromDate = new Date();
        }

        this.$location.search({
            fromDate: this.$filter('date')(this.fromDate, "yyyy-MM-dd"),
            toDate: this.$filter('date')(this.toDate, "yyyy-MM-dd")
        });
    }

    setDateRange() {
        const dayInWeek = moment().year(this.year).isoWeek(this.weekNumber);
        this.fromDate = new Date(dayInWeek.startOf('isoweek').format('YYYY-MM-DD'));
        this.toDate = new Date(dayInWeek.endOf('isoweek').format('YYYY-MM-DD'));

        this.$location.search({
            fromDate: this.$filter('date')(this.fromDate, "yyyy-MM-dd"),
            toDate: this.$filter('date')(this.toDate, "yyyy-MM-dd")
        });
    }

    yearChanged() {
        this.numberOfWeeks = moment().year(this.year).isoWeeksInYear();
        if (this.weekNumber == 53 && this.numberOfWeeks == 52) {
            this.weekNumber = 52;
        }
        this.setDateRange();
    }

    defineWeeks() {
        _.times(53, (i: number) => this.weeks.push(i));
    }

    defineYears() {
        _.times(150, (i: number) => this.years.push(1950 + i));
    }

    setCurrentYear(date?: Date) {
        this.year = moment(date ? date : new Date()).year();
        this.yearChanged();
    }

    setCurrentWeekNumber(date?: Date) {
        this.weekNumber = moment(date ? date : new Date).isoWeek();
    }

    deleteShipment(ev, item) {
        const confirm = this.$mdDialog.confirm()
            .title('Bekreft sletting')
            .textContent('Dette vil slette data')
            .ariaLabel('jaja')
            .targetEvent(ev)
            .ok('Slett')
            .cancel('Avbryt');
        this.$mdDialog.show(confirm).then(() => {
            this.Shipments.deleteShipment({shipmentId: item.shipmentId}).$promise.then((success) => {
                this.getShipments();
            }, (error) => {
                this.toastService.parseError(error);
            })
        }, () => {
        });
    }

    lineChanged(item) {
        if (item.shipmentId || item.shipmentid === 0) {
            this.Shipments.updateShipment({shipmentId: item.shipmentId}, item).$promise.then((shipment) => {
                item = shipment;
            }, (error) => {
                this.toastService.parseError(error);
            });
        } else {
            this.Shipments.createShipment({
                date: this.$filter('date')(item.deliveryDate, 'yyyy-MM-dd'),
                customerNo: item.customerNo,
                customerName: item.deliveryCustomerName,
                address: item.deliveryAddress1,
                address2: item.deliveryAddress2,
                chartererNo: item.chartererCompanyNo
            }, item).$promise.then((shipment) => {
                item.shipmentId = shipment.shipmentId;
            }, (error) => {
                this.toastService.parseError(error);
            });
        }
    }

    goToDetailsForBookingLine(item) {
        const parameters = {
            date: this.$filter('date')(item.deliveryDate, 'yyyy-MM-dd'),
            customerNo: item.customerNo,
            customerName: item.deliveryCustomerName,
            address: item.deliveryAddress1,
            chartererNo: item.chartererCompanyNo
        };
        this.$state.go('loggedin.expedition_booking_bookingdetails', parameters);
    }

    addComment(ev, item) {
        this.$mdDialog.show({
            template: '<add-comment-dialog comment="c.currentComment"></add-comment-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: 'c',
            controller: <any>[function () {
                this.currentComment = item.comment;
            }]
        }).then((comment) => {
            if (comment) {
                item.comment = comment.comment;
                this.lineChanged(item);
            }
        });
    }

    getShipments() {
        this.orderCount = 0;
        this.Shipments.getShipments({
            fromDate: this.$filter('date')(this.fromDate, "yyyy-MM-dd"),
            toDate: this.$filter('date')(this.toDate, "yyyy-MM-dd")
        }).$promise.then((listOfListOfBookings: Array<{ bookings: Array<any> }>) => {
            if (listOfListOfBookings) {
                this.orderCount = 0;
                this.bookings = _.map(_.groupBy(_.filter(_.flatMap(listOfListOfBookings['shipmentsByDate'], (bookings: Array<any>) => {
                    return _.map(bookings, booking => booking)
                }), booking => booking.deliveryDate), 'locationName'), (val, key) => {
                    if (!this.expanded[key]){
                        this.expanded[key] = {};
                    }
                    if (!this.search[key]) {
                        this.search[key] = {};
                    }
                    _.forEach(_.uniqBy(val, 'deliveryDate'), (date) => {
                        this.expanded[key][date.deliveryDate] = true;
                        this.search[key][date.deliveryDate] = "";
                    });
                    this.orderCount += val.length;
                    return {
                        locationName: key,
                        dates: _.groupBy(val, 'deliveryDate'),
                        orderCount: val.length
                    }
                });
            }
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    bookingFilter = function(date, search) {
        return (booking) => {
            let searchString = search[date];
            if (searchString) {
                searchString = searchString.toLowerCase();
                const matchAddress = `${booking.deliveryCustomerName} - ${booking.deliveryPostCode} - ${booking.deliveryAddress1} - ${booking.deliveryAddress2}`.toLowerCase().includes(searchString);
                const matchCustomerNo = booking.customerNo ? booking.customerNo.toString().toLowerCase().includes(searchString) : false;
                const matchTerminal = booking.terminal ? booking.terminal.toString().toLowerCase().includes(searchString) : false;
                return matchAddress || matchCustomerNo || matchTerminal;
            } else {
                return true;
            }
        }
    };
}

class BookingOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcBookingController";
    public template: any = require('./booking.html');
}

rkcApp.controller("rkcBookingController", ['toastService', '$state', '$stateParams', '$filter', '$location', '$mdDialog', 'Shipments', 'ShipmentDefaults', '$scope', function (toastService, $state, $stateParams, $filter, $location, $mdDialog, Shipments, ShipmentDefaults, $scope) {
    return new BookingController(toastService, $state, $stateParams, $filter, $location, $mdDialog, Shipments, ShipmentDefaults, $scope);
}])
    .component("rkcBooking", new BookingOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/booking/booking.ts
 **/